// ─── Button types ─────────────────────────────────────────────────────────────

export const BUTTON_TYPE_PRIMARY = "primary";
export const BUTTON_TYPE_DEFAULT = "default";
export const BUTTON_TYPE_TEXT = "text";
export const BUTTON_TYPE_LINK = "link";

// ─── Alert / tag / text types ─────────────────────────────────────────────────

export const TYPE_SUCCESS = "success";
export const TYPE_ERROR = "error";
export const TYPE_WARNING = "warning";
export const TYPE_INFO = "info";
export const TYPE_SECONDARY = "secondary";
export const TYPE_DANGER = "danger";

// ─── Sizes ────────────────────────────────────────────────────────────────────

export const SIZE_SMALL = "small";
export const SIZE_MIDDLE = "middle";
export const SIZE_LARGE = "large";

